"use strict";

/**
 * Collect data how user interacts with video player
 * @method FlixUserBehavior.init(player, vid, videoMeta)
 */
;
var FlixUserBehavior = function () {
  // All logic will be executed after video player loaded
  document.addEventListener('flix:load', onPageLoad);
  document.addEventListener('flix:video:ready', function (e) {
    player = e.detail.player;
    setPlayerEventHandlers();
    document.addEventListener('webkitfullscreenchange', onFullscreenChangeVideoData);
    document.addEventListener('mozfullscreenchange', onFullscreenChangeVideoData);
    document.addEventListener('MSFullscreenChange', onFullscreenChangeVideoData);
    document.addEventListener('fullscreenchange', onFullscreenChangeVideoData);
  });
  document.addEventListener('flix:thumbs:up:add', function () {
    data.liked = true;
    data.disliked = false;
  });
  document.addEventListener('flix:thumbs:up:remove', function () {
    data.liked = false;
  });
  document.addEventListener('flix:thumbs:down:add', function () {
    data.disliked = true;
    data.liked = false;
  });
  document.addEventListener('flix:thumbs:down:remove', function () {
    data.disliked = false;
  });

  // window.addEventListener('pagehide', send);

  window.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      send();
    }
  });
  window.addEventListener('beforeunload', function () {
    send();
  });
  var seekPoint = null;
  var NO_ERROR = 0,
    ERROR_ON_LONG_LOAD = 2,
    ERROR_NOT_FOUND = 3,
    ERROR_NOT_PLAY = 4,
    ERROR_NOT_INITIALIZED = 1010;
  var sent = false;

  /**
   * @type {Plyr}
   */
  var player;

  /**
   * Data to fill during video play and later send to collector
   */
  var data = {};
  function getEndpoint() {
    return Flix.env == 'production' ? 'https://ac2.tnaflix.com/ub.php' : '/video_data.php';
  }

  /**
   * Entrypoint 
   */
  function onPageLoad() {
    if (FlixUtils.isCrawler() || !Flix.isTna() || !document.querySelector('#video-meta')) {
      return;
    }
    if (Object.keys(data).length) {
      send();
    }
    data = getInitialData();
    data.vid = document.querySelector('#video-meta').getAttribute('data-vid');
    data.meta = JSON.parse(document.querySelector('#video-meta').textContent);

    // Read once, so a tab opened later during playback doesn't take over the record
    data.stats_cross_id = FlixUtils.stats.getCrossId();
    data.tab_id = FlixUtils.stats.getTabId();
    sent = false;
    document.addEventListener('click', function (e) {
      if (e.target.closest('.favorite-event-add')) {
        data.favorite = true;
      } else if (e.target.closest('.favorite-event-remove')) {
        data.favorite = false;
      } else if (e.target.closest('.watch_later-event-add')) {
        data.watch_later = true;
      } else if (e.target.closest('.watch_later-event-remove')) {
        data.watch_later = false;
      }
      ;
    });
    document.querySelectorAll('#share-links a.dropdown-item').forEach(function (el) {
      el.addEventListener('click', function () {
        data.shared = true;
      });
    });

    // When stats collector ready to send data
    // document.addEventListener('_stats_collector.send', send);
  }
  function getInitialData() {
    return {
      'vid': 0,
      'meta': {
        'categories': [],
        'tags': [],
        'stars': [],
        'studio': null,
        'likes': 0,
        'dislikes': 0,
        'views': 0,
        'downloads': 0,
        'favorites': 0,
        'shares': 0,
        'duration': 0
      },
      'videoInfo': [],
      'playing': [],
      'seeking': [],
      'player_size': [],
      'full_screen': false,
      'start': Math.floor(new Date().getTime() / 1000),
      'end': Math.floor(new Date().getTime() / 1000),
      'start_ms': Date.now(),
      'end_ms': Date.now(),
      'stats_cross_id': '0',
      // set in onPageLoad()
      'tab_id': '0',
      // set in onPageLoad()

      'bookmarked': true,
      'watch_later': false,
      'favorite': false,
      'downloaded': false,
      'shared': false,
      'liked': false,
      'disliked': false,
      'referrer': window['referrer_fallback'],
      'statsUID': _getStatsUid(),
      'is_mobile': true,
      // evaluated in the send() function

      'liked_position': 0,
      'liked_duration': 0
    };
  }
  /**
   * Add data to stats collector on page close
   */
  function __send_new() {
    data.end = Math.floor(new Date().getTime() / 1000);

    // If user spent at least 5 sec on page and played at least something
    if (data.end - data.start > 5 && data.playing.length > 0) {
      _stats_collector.add('user_behavior', data);
    }
  }

  /**
   * Old send. should be replaced with the new one
   */
  function send() {
    if (!data.vid || sent) {
      return;
    }
    sent = true;
    data.is_mobile = FlixUtils.isMobile();
    data.end = Math.floor(new Date().getTime() / 1000);
    data.end_ms = Date.now();
    var fd = new FormData();
    fd.append('data', JSON.stringify(data));
    if (typeof navigator.sendBeacon !== 'function' || !navigator.sendBeacon(getEndpoint(), fd)) {
      // Fallback if beacon is not supported
      var xhr = new XMLHttpRequest();
      xhr.open("POST", getEndpoint(), false);
      xhr.setRequestHeader('Content-type', 'application/json');
      xhr.send(JSON.stringify(data));
    }
    sent = false;
    data = getInitialData();
  }
  function setPlayerEventHandlers() {
    if (FlixUtils.isCrawler()) {
      return;
    }
    player.on('play', function () {
      data.playing.push({
        'type': 'play',
        'ts': Math.floor(new Date().getTime() / 1000),
        'vidTime': Math.floor(player.media.currentTime)
      });
      document.dispatchEvent(new CustomEvent('fatigueLogEvent', {
        detail: {
          VID: data.vid,
          eventType: 'video_play',
          thumbIndex: 0,
          thumbPosition: 0
        }
      }));
      setTimeout(function () {
        if (!player) {
          return;
        }
        data.videoInfo.push({
          'videoError': player.media.error ? player.media.error.code : null,
          'error': NO_ERROR,
          'readyState': player.media.readyState,
          'src': player.media.currentSrc,
          'ts': Math.floor(new Date().getTime() / 1000),
          'seek': 0
        });
      }, 2000);
    });
    player.on('pause', function () {
      data.playing.push({
        'type': 'pause',
        'ts': Math.floor(new Date().getTime() / 1000),
        'vidTime': Math.floor(player.media.currentTime)
      });
    });
    player.on('ended', function () {
      data.playing.push({
        'type': 'ended',
        'ts': Math.floor(new Date().getTime() / 1000),
        'vidTime': Math.floor(player.media.currentTime)
      });
    });
    player.on("stalled", function () {
      data.videoInfo.push({
        'videoError': player.media.error ? player.media.error.code : null,
        'error': ERROR_ON_LONG_LOAD,
        'readyState': player.media.readyState,
        'src': player.media.currentSrc,
        'ts': Math.floor(new Date().getTime() / 1000),
        'seek': 0
      });
    });
    player.on('seeking', function () {
      seekStart(player.media.currentTime);
      data.videoInfo.push({
        'videoError': player.media.error ? player.media.error.code : null,
        'error': NO_ERROR,
        'readyState': player.media.readyState,
        'src': player.media.currentSrc,
        'ts': Math.floor(new Date().getTime() / 1000),
        'seek': 1
      });
    });
    player.on('seeked', function () {
      seekEnd(player.media.currentTime);
    });
  }
  function onFullscreenChangeVideoData() {
    if (document.fullscreenElement) {
      data.player_size.push({
        'type': 'fullscreen',
        'ts': Math.floor(new Date().getTime() / 1000),
        'vidTime': Math.floor(player.media.currentTime)
      });
      data.full_screen = true;
    } else {
      data.player_size.push({
        'type': 'windowed',
        'ts': Math.floor(new Date().getTime() / 1000),
        'vidTime': Math.floor(player.media.currentTime)
      });
    }
  }
  function seekStart(posTime) {
    if (seekPoint === null) {
      seekPoint = {
        'ts': Math.floor(Date.now() / 1000),
        'posTime': Math.floor(posTime)
      };
    }
  }
  function seekEnd(posTime) {
    // Only if cursor moved for at least 2 seconds
    if (seekPoint !== null && Math.abs(posTime - seekPoint.posTime) >= 2) {
      data.seeking.push([seekPoint, {
        'ts': Math.floor(Date.now() / 1000),
        'posTime': Math.floor(posTime)
      }]);
      seekPoint = null;
    }
  }

  /**
   * Fatigue thingy
   * 
   * @returns {string|int}
   */
  function _getStatsUid() {
    if (FlixUtils.hasCookie('_auid')) {
      return FlixUtils.getCookie('_auid');
    } else {
      var _id = Math.random().toString().slice(2, 16);
      FlixUtils.setCookie('_auid', _id, 365);
      return _id;
    }
  }
  return {
    data: data
  };
}();